import { useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * PDF Tools index page — sub-tab hub for the three PDF-related utilities.
 * Renders a stack of cards that link out to each individual tool page.
 */
export default function PdfToolsIndex() {
  return (
    <div className="p-4 sm:p-8 max-w-5xl mx-auto" data-testid="pdf-tools-index">
      <div className="mb-8">
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">PDF Tools</div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tighter text-slate-900">Bulk PDF utilities</h1>
        <p className="text-slate-500 text-sm mt-2 max-w-2xl">
          Purpose-built helpers around invoice PDFs — extraction, reconciliation, and bulk export.
          Everything runs on open-source OCR + the bundled AI parser; no third-party paid services.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <ToolCard
          to="/pdf-tools/purchase-bills"
          testid="tool-purchase-bills"
          badge="Extract"
          title="Purchase Bill Extractor"
          desc="Drop supplier PDFs — vector or scanned — and get a multi-sheet Excel with supplier, invoice no, HSN, qty, rate, taxes and grand totals. Optional save-to-Purchases."
        />
        <ToolCard
          to="/pdf-tools/sales-bills"
          testid="tool-sales-bills"
          badge="Extract"
          title="Sales Bill Extractor"
          desc="Same pipeline but for sales invoices from other systems — Excel download only (never touches your existing invoices)."
        />
        <ToolCard
          to="/pdf-tools/gstr2a"
          testid="tool-gstr2a"
          badge="Reconcile"
          title="GSTR-2A Reconciliation"
          desc="Upload the GSTR-2A JSON or Excel from the GST portal — instantly see which invoices match, mismatch, are missing from portal, or missing from your books."
        />
        <ToolCard
          to="/invoices"
          testid="tool-bulk-download"
          badge="Export"
          title="Bulk PDF Download"
          desc="Select multiple invoices on the Invoices list and download all their PDFs bundled into a single ZIP. Perfect for monthly filing / accountant handoff."
        />
      </div>
    </div>
  );
}

const ToolCard = ({ to, testid, badge, title, desc }) => (
  <NavLink
    to={to}
    data-testid={testid}
    className="bg-white border border-slate-200 hover:border-slate-900 rounded-sm p-6 transition-all group"
  >
    <span className="text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-sm bg-slate-900 text-white">{badge}</span>
    <h2 className="mt-3 text-xl font-bold text-slate-900 group-hover:underline">{title}</h2>
    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{desc}</p>
  </NavLink>
);
